import { Box } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";
import AuthSidebar from "./Sidbar";
import useVirtualViewport from "../../../hooks/useVirtualViewport";
import { useAppDispatch } from "../../../hooks/useRedux";
import {
  setHasScroll,
  setOpenAuthSidebar,
  setOpenDriverSidebar,
  setOpenOwnerSidebar,
} from "../../../redux/features/settingSlice";
import CustomSnackbar from "../../components/CustomSnackbar";
import CustomDialogBox from "../../components/CustomDialogBox";
import Goftino from "../../components/Goftino";

export default function AuthLayout() {
  const divRef = useRef<HTMLDivElement>(null);

  const { pathname } = useLocation();

  const dispatch = useAppDispatch();
  useEffect(() => {
    setTimeout(() => {
      dispatch(setOpenAuthSidebar(false));
      dispatch(setOpenDriverSidebar(false));
      dispatch(setOpenOwnerSidebar(false));
    }, 100);
  }, [pathname]);

  useEffect(() => {
    const divElement = divRef.current;

    const handleScroll = () => {
      if (divElement && divElement.scrollTop > 5) {
        dispatch(setHasScroll(true));
      } else {
        dispatch(setHasScroll(false));
      }
    };

    if (divElement) {
      divElement.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (divElement) {
        divElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  return (
    <Box
      ref={divRef}
      dir="rtl"
      sx={{
        height: `100vh`,
        backgroundColor: "bgColor.grey100",
        paddingBottom: pathname === "/driver/dashboard" ? "58px" : "70px",
        paddingTop: pathname === "/driver/dashboard" ? "0px" : "70px",
        position: "relative",
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        overflowX: "hidden",
        "&::-webkit-scrollbar": {
          "-webkit-appearance": "none",
          width: "0px", // Hides scrollbar for WebKit browsers
        },
        scrollbarWidth: "none", // Hides scrollbar for Firefox
      }}
    >
      <AuthSidebar />
      <CustomDialogBox />
      <CustomSnackbar />
      <Goftino />
      <Outlet />
    </Box>
  );
}
